function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Overlay } from '../../../Overlay';
import { Popover } from '../../../Popover';
import { isHeaderOverlayOpen, generateUniqueId } from '../../../Utils/helper';
import { getOrganisationLogo } from '../../helper';
import ChevronDown from '@dtsl/icons/dist/icons/react/ChevronDown';
import Lock from '@dtsl/icons/dist/icons/react/Lock';
function MobileLeftActions(props) {
  const {
    logo = {},
    leftActions = []
  } = props;
  const {
    svg,
    imageUrl
  } = logo;
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const mobileLeftActionRef = React.useRef(null);
  const onClickLink = event => {
    event.preventDefault();
    if (isHeaderOverlayOpen() && !isOverlayOpen) {
      setTimeout(() => {
        setIsOverlayOpen(!isOverlayOpen);
      }, 500);
    } else {
      setIsOverlayOpen(!isOverlayOpen);
    }
    mobileLeftActionRef?.current?.closest('.sib-header').classList.toggle('sib-header--toggled');
  };
  const handleDocumentClick = event => {
    if (mobileLeftActionRef.current) {
      if (!mobileLeftActionRef.current.contains(event.target) && isOverlayOpen) {
        setIsOverlayOpen(false);
        mobileLeftActionRef?.current?.closest('.sib-header').classList.remove('sib-header--toggled');
      }
    }
  };
  useEffect(() => {
    document.addEventListener('click', handleDocumentClick);
    return () => {
      document.addEventListener('click', handleDocumentClick);
    };
  }, [isOverlayOpen]);
  return /*#__PURE__*/React.createElement("li", {
    ref: mobileLeftActionRef
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    target: "_self",
    "aria-label": "Brevo header organisation label",
    onClick: e => onClickLink(e),
    className: "sib-header__mobile-organization"
  }, getOrganisationLogo({
    imageUrl,
    svg
  }), /*#__PURE__*/React.createElement(ChevronDown, {
    className: `arrow icon-right ${isOverlayOpen ? 'rotate-arrow' : ''}`
  })), /*#__PURE__*/React.createElement(Overlay, {
    isOpen: isOverlayOpen,
    className: "sib-mobile-left-menu"
  }, leftActions.map((action, index) => {
    const {
      type,
      data: {
        to = '#',
        title,
        target = '_self',
        onClick = () => {},
        locked,
        popoverData
      } = {},
      active
    } = action;
    const leftMenuItemClasses = classNames({
      active: active,
      'sib-mobile-left-menu__item': true
    });
    const onClickWrapper = event => {
      if (locked || to === '#') {
        event.stopPropagation();
        event.preventDefault();
        if (locked) return;
      }
      setIsOverlayOpen(false);
      mobileLeftActionRef?.current?.closest('.sib-header').classList.remove('sib-header--toggled');
      onClick(event);
    };
    const tab =
    /*#__PURE__*/
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    React.createElement("a", {
      key: index,
      id: `hdrTabMob-${generateUniqueId()}`,
      target: target,
      className: leftMenuItemClasses,
      onClick: onClickWrapper,
      href: !locked ? to : '#'
    }, locked && /*#__PURE__*/React.createElement(Lock, {
      className: "icon-right"
    }), title);
    if (type === 'tab') {
      if (locked && popoverData) {
        return /*#__PURE__*/React.createElement(Popover, _extends({}, popoverData, {
          key: index,
          trigger: ['click']
        }), tab);
      }
      return tab;
    }
  })));
}
MobileLeftActions.propTypes = {
  logo: PropTypes.object,
  leftActions: PropTypes.array
};
export default MobileLeftActions;